import type React from 'react';
import { cx } from 'class-variance-authority';

import { Icon } from '@nvision/ui';

import styles from './page.module.css';

interface PageProps {
  children: React.ReactNode;
}
export const Page: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.pageLayout}>{children}</div>;
};

interface SideBarHeaderProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  icon?: React.ReactElement;
  title: string;
}

export const SideBar: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = (props) => {
  return <div {...props} className={cx(styles.sideBar, props.className)} />;
};

export const SideBarHeader: React.FC<SideBarHeaderProps> = ({ title, icon }) => {
  return (
    <div className={styles.sideBarHeader}>
      {icon ?? <Icon name="settings-2" size={20} className={styles.sideBarHeaderIcon} />} {title}
    </div>
  );
};

export const SideBarFooter: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = (props) => {
  return <div className={styles.sideBarFooter} {...props} />;
};

export const SideBarMain: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = (props) => {
  return <div {...props} className={cx(styles.sideBarMain, props.className)} />;
};
